import { render, staticRenderFns } from "./DashboardPushSection.vue?vue&type=template&id=d0f88956&scoped=true"
import script from "./DashboardPushSection.vue?vue&type=script&lang=js"
export * from "./DashboardPushSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardPushSection.vue?vue&type=style&index=0&id=d0f88956&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f88956",
  null
  
)

export default component.exports